module.exports = __webpack_public_path__ + "static/img/produto_p.ea89aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/laranja-zero/produto_p.png
// module id = Cgm/
// module chunks = 0